import { useState } from "react"
import { Link } from "react-router-dom"
import styles from "./live-tournaments-list.module.css"

const mockLiveTournaments = [
  {
    id: 1,
    game: "Mobile Legends: Bang Bang",
    gameName: "MLBB",
    tournamentName: "Pro League Season 5",
    team1: "Phoenix Rising",
    team2: "Dragon Slayers",
    status: "Live",
    viewers: 12500,
    thumbnail: "/statics/mobile-legends-esports.jpg",
    startTime: "2025-10-22T18:00:00",
    prizePool: "₹50,000",
  },
  {
    id: 2,
    game: "Valorant",
    gameName: "Valorant",
    tournamentName: "Champions Cup 2025",
    team1: "Sentinels",
    team2: "FaZe Clan",
    status: "Live",
    viewers: 25000,
    thumbnail: "/statics/valorant-esports.jpg",
    startTime: "2025-10-22T19:30:00",
    prizePool: "₹1,00,000",
  },
  {
    id: 3,
    game: "PUBG Mobile",
    gameName: "PUBG",
    tournamentName: "Global Championship",
    team1: "Team Liquid",
    team2: "Nova Esports",
    status: "Live",
    viewers: 18000,
    thumbnail: "/statics/pubg-mobile-esports.jpg",
    startTime: "2025-10-22T20:00:00",
    prizePool: "₹75,000",
  },
]

export default function LiveTournamentsList() {
  const [filter, setFilter] = useState("all")

  const filteredTournaments =
    filter === "all" ? mockLiveTournaments : mockLiveTournaments.filter((t) => t.gameName === filter)

  return (
    <div className={styles.container}>
      <div className={styles.filterSection}>
        <h2 className={styles.filterTitle}>Filter by Game</h2>
        <div className={styles.filterButtons}>
          <button
            className={`${styles.filterBtn} ${filter === "all" ? styles.active : ""}`}
            onClick={() => setFilter("all")}
          >
            All Games
          </button>
          <button
            className={`${styles.filterBtn} ${filter === "MLBB" ? styles.active : ""}`}
            onClick={() => setFilter("MLBB")}
          >
            Mobile Legends
          </button>
          <button
            className={`${styles.filterBtn} ${filter === "Valorant" ? styles.active : ""}`}
            onClick={() => setFilter("Valorant")}
          >
            Valorant
          </button>
          <button
            className={`${styles.filterBtn} ${filter === "PUBG" ? styles.active : ""}`}
            onClick={() => setFilter("PUBG")}
          >
            PUBG Mobile
          </button>
          <button
            className={`${styles.filterBtn} ${filter === "FF" ? styles.active : ""}`}
            onClick={() => setFilter("FF")}
          >
            Free Fire
          </button>
        </div>
      </div>

      <div className={styles.tournamentsGrid}>
        {filteredTournaments.map((tournament) => (
          <Link key={tournament.id} to={`/tournament/live/${tournament.id}`}>
            <div className={styles.tournamentCard}>
              <div className={styles.thumbnailContainer}>
                <img
                  src={tournament.thumbnail || "/placeholder.svg"}
                  alt={tournament.tournamentName}
                  className={styles.thumbnail}
                />
                {tournament.status === "Live" ? (
                  <div className={styles.liveBadge}>
                    <span className={styles.liveDot}>●</span>
                    {tournament.status}
                  </div>
                ) : (
                  <div className={styles.notLiveBadge}>
                    <span className={styles.liveDot}>●</span>
                    {tournament.status}
                  </div>
                )}
                <div className={styles.viewersCount}>{tournament.viewers.toLocaleString()} watching</div>
              </div>

              <div className={styles.cardContent}>
                <h3 className={styles.tournamentName}>{tournament.tournamentName}</h3>

                <div className={styles.teamsContainer}>
                  <div className={styles.team}>{tournament.team1}</div>
                  <span className={styles.vs}>vs</span>
                  <div className={styles.team}>{tournament.team2}</div>
                </div>

                <div className={styles.cardFooter}>
                  <span className={styles.game}>{tournament.game}</span>
                  <span className={styles.prizePool}>{tournament.prizePool}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
